// extracted by mini-css-extract-plugin
export default {"inactive-clients-delete-button":"deletebuttoncell_inactive-clients-delete-button__8LisX","locked":"deletebuttoncell_locked__M-6OV"};